import React from "react";

function Header() {
  return (
    <header>
      <h1 className="text-center"> Frequently Asked Questions</h1>
    </header>
  );
}

export default Header;
